import { useEffect, useMemo, type ReactNode } from 'react';

import { useRecordings } from '@/features/rpa/recorder/hooks/useRecordings';
import {
  createDefaultRpaRecorderLifecycleDeps,
  startRpaRecorderLifecycle,
  type RpaRecorderLifecycleDeps,
} from '@/features/rpa/recorder/lifecycle/rpa-recorder-lifecycle-helpers';

function useRpaRecorderLifecycle(deps?: RpaRecorderLifecycleDeps): void {
  const {
    addUploading,
    applyUploadState,
    applyUploadProgress,
    applyAnalysisStatus,
    mergePersisted,
  } = useRecordings();
  const resolvedDeps = useMemo(
    () => deps ?? createDefaultRpaRecorderLifecycleDeps(),
    [deps]
  );

  useEffect(() => {
    return startRpaRecorderLifecycle(resolvedDeps, {
      addUploading,
      applyUploadState,
      applyUploadProgress,
      applyAnalysisStatus,
      mergePersisted,
    });
  }, [
    addUploading,
    applyAnalysisStatus,
    applyUploadProgress,
    applyUploadState,
    mergePersisted,
    resolvedDeps,
  ]);
}

export function RpaRecorderLifecycleProvider({
  children,
  deps,
}: {
  readonly children: ReactNode;
  readonly deps?: RpaRecorderLifecycleDeps;
}): ReactNode {
  useRpaRecorderLifecycle(deps);
  return <>{children}</>;
}
